// extracted by mini-css-extract-plugin
export var active = "_25-a";
export var activeIndicator = "_25-8";
export var animate = "_25-9";
export var disabled = "_25-b";
export var fullWidth = "_25-2";
export var lg = "_25-7";
export var md = "_25-6";
export var redoButtonTabGroup = "_25-0";
export var sm = "_25-5";
export var tabButton = "_25-3";
export var tabButtonsContainer = "_25-1";
export var xs = "_25-4";